import React from 'react';
import {  useSelector } from 'react-redux';
import DrawerUserInfo from '../../../components/common/header/DrawerUserInfo';


const DrawerUserInfoContainer = () => {
    const { user } = useSelector(({ auth }) => ({
        user: auth.user,
    }));
    return (
        <DrawerUserInfo user={user} />
    )
}

export default DrawerUserInfoContainer